import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NavigateService } from '../service/navigate.service';
import { PersonService } from '../service/person.service';
declare var $: any;

@Component({
	selector: 'app-person',
	templateUrl: './person.component.html',
	styleUrls: ['./person.component.styl','../share/breadcrumb/breadcrumb.component.styl']
})
export class PersonComponent implements OnInit {
	modal = {
		title: 'CHINAICAC MEMBER SIGN IN',
		isSigninShow: false,
		closeShow: false,
	};
	isLogin: boolean;

	currentTab: string;
    tabList: any = [
        {name: 'My Profile', link: './person-info', icon: 'person-info'},
        {name: 'Modify Password', link: './modify-pwd', icon: 'password'},
        {name: 'My Q&A', link: './my-q-and-a', icon: 'icon_q&a', iconStyle: 'width: 24px'},
        {name: 'My Comments', link: './my-comments', icon: 'icon_comments'},
        {name: 'Message Center', link: './message-center', icon: 'icon_message'},
    ];

	constructor(
        private router: Router,
        private domSanitizer: DomSanitizer,
        private navigateService: NavigateService,
		private personService: PersonService
	){
        this.currentTab = this.tabList.find(item => this.router.url.includes(item.link.slice(1))).name;
    }

	ngOnInit(){
		this.personService.getUserInfo().subscribe(res => {
			res.ok ? this.success() : this.modal.isSigninShow = true ;
		});
	}

	success(){
		this.isLogin = true;
		setTimeout(function(){
			$('.wrap-box').css("min-height", $(window).height());
		}, 0);
	}
    
    // style xss
    trustedStyle(style: string){
        return this.domSanitizer.bypassSecurityTrustStyle(style);
    }

	onConfirm(){
		this.navigateService.pushToRoute('./home');
	}

}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/person/person.component.ts